<div id="wrap">
  <div>
    <apx-chart #chart *ngIf="chartOptions" [series]="chartOptions?.series!" [chart]="chartOptions.chart!"
      [dataLabels]="chartOptions.dataLabels!" [labels]="chartOptions.labels!" [plotOptions]="chartOptions.plotOptions!"
      [yaxis]="chartOptions.yaxis!" [xaxis]="chartOptions.xaxis!" [subtitle]="chartOptions.subtitle!"
      [colors]="chartColors" [states]="chartOptions.states!" [title]="chartOptions.title!"
      [tooltip]="chartOptions.tooltip!"></apx-chart>
  </div>
</div>